import { render, staticRenderFns } from "./ExamAdministration.vue?vue&type=template&id=840a39f2&scoped=true&"
import script from "./ExamAdministration.vue?vue&type=script&lang=js&"
export * from "./ExamAdministration.vue?vue&type=script&lang=js&"
import style0 from "./ExamAdministration.vue?vue&type=style&index=0&id=840a39f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840a39f2",
  null
  
)

export default component.exports